module.exports = __webpack_public_path__ + "img/hyacintus-henry-djantoko.faa1b408.png";